export enum DatepickerTab {
  CustomRange = 'custom_range',
  Month = 'month',
}